var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeOwner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_370_1",
    "data-name": "Componente 370 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_11737",
    "data-name": "Rettangolo 11737",
    width: 25,
    height: 25,
    rx: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23509",
    "data-name": "Raggruppa 23509",
    transform: "translate(0.045 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user-check",
    "data-name": "Icon feather-user-check",
    transform: "translate(2.455 5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33444",
    "data-name": "Tracciato 33444",
    d: "M9.833,25.833V24.722A2.222,2.222,0,0,0,7.611,22.5H3.722A2.222,2.222,0,0,0,1.5,24.722v1.111",
    transform: "translate(0 -11.333)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_33445",
    "data-name": "Tracciato 33445",
    d: "M11.194,6.722A2.222,2.222,0,1,1,8.972,4.5,2.222,2.222,0,0,1,11.194,6.722Z",
    transform: "translate(-3.306)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_23508",
    "data-name": "Raggruppa 23508",
    transform: "translate(1 -1.844)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-left",
    "data-name": "Icon awesome-arrow-left",
    d: "M3.312,7.892l-.286.286a.308.308,0,0,1-.436,0l-2.5-2.5a.308.308,0,0,1,0-.436l2.5-2.5a.308.308,0,0,1,.436,0l.286.286a.309.309,0,0,1-.005.442L1.755,4.943H7.768a.308.308,0,0,1,.309.309v.412a.308.308,0,0,1-.309.309H1.755L3.307,7.45A.307.307,0,0,1,3.312,7.892Z",
    transform: "translate(12.516 3.197)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-left-2",
    "data-name": "Icon awesome-arrow-left",
    d: "M4.761,7.892l.286.286a.308.308,0,0,0,.436,0l2.5-2.5a.308.308,0,0,0,0-.436l-2.5-2.5a.308.308,0,0,0-.436,0l-.286.286a.309.309,0,0,0,.005.442L6.317,4.943H.305A.308.308,0,0,0,0,5.252v.412a.308.308,0,0,0,.309.309H6.317L4.766,7.45A.307.307,0,0,0,4.761,7.892Z",
    transform: "translate(12.528 7.586)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeOwner);
export default __webpack_public_path__ + "static/media/change-owner.28b5a8117864977ea70fd1fd8a4e9e0c.svg";
export { ForwardRef as ReactComponent };